export var DEFAULT_VOLUME = 1;
export var PLAYER_KEY = '__PLAYER_KEY__';